import type { OptionItem } from '../../common/types/option-item';

export const perPageOptions: OptionItem[] = [
  { id: 25, title: '25 на сторінку' },
  { id: 50, title: '50 на сторінку' },
  { id: 100, title: '100 на сторінку' }
];
